export enum SocialMedia {
	GITHUB = 'github',
	LINKEDIN = 'linkedin',
	FACEBOOK = 'facebook',
	TWITTER = 'twitter',
	WEBSITE = 'website'
}
